import { createLucideIcon } from 'lucide-react';
export const BarChart = createLucideIcon('bar-chart', [
  [
    'path',
    {
      d: 'M16.5749 3V21H22V3H16.5749Z',
      key: '1nwlxs',
    },
  ],
  [
    'path',
    {
      d: 'M2 7.5V21H7.4251V7.5H2Z',
      key: 'a905x1',
    },
  ],
  [
    'path',
    {
      d: 'M9.2875 12V21H14.7126V12H9.2875Z',
      key: '2v4fon',
    },
  ],
]);
